import { render, staticRenderFns } from "./HistoryThreeInOne.vue?vue&type=template&id=2ddc64d4&scoped=true&"
import script from "./HistoryThreeInOne.vue?vue&type=script&lang=js&"
export * from "./HistoryThreeInOne.vue?vue&type=script&lang=js&"
import style0 from "./HistoryThreeInOne.vue?vue&type=style&index=0&id=2ddc64d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc64d4",
  null
  
)

export default component.exports